<div class="home-section-wrapper">
  <mat-drawer-container #matDrawerContainer (backdropClick)="closeBackdrop()">
    <mat-drawer role="navigation" class="fixed" #leftnav [opened]="leftSideNav">
      <div fxLayout="row">
        <uni-left-sidenav-collapsed
          (toggle)="closeBackdrop()"
          [showSidenav]="true"
          [showDiscoverSection]="false">
        </uni-left-sidenav-collapsed>
        <ng-container *ngTemplateOutlet="sidenavContent"> </ng-container>
      </div>
    </mat-drawer>

    <mat-drawer-content>
      <div
        class="fixed top-0"
        fxLayout="row"
        *ngIf="!isSmall"
        style="filter: drop-shadow(0px 0px 50px rgba(0, 0, 0, 0.1))">
        <uni-left-sidenav-collapsed
          (toggle)="leftnav.toggle()"
          [showSidenav]="true"
          [showDiscoverSection]="false">
        </uni-left-sidenav-collapsed>
        <ng-container *ngIf="isLarge">
          <ng-container *ngTemplateOutlet="sidenavContent"> </ng-container>
        </ng-container>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>

<main class="main-section">
  <ng-container *ngIf="isLoading; else competitionTemplate">
    <div fxLayout="row" fxLayoutAlign="center center" style="height: 50vh">
      <uni-loader></uni-loader>
    </div>
  </ng-container>

  <ng-template #competitionTemplate>
    <header
      class="header-section sparro-bg-white overflow-hidden bottom-margin"
      [ngClass.lt-lg]="{ 'header-section-sm': true }">
      <!-- <div parallax [config]="{axis: 'Y', speed: 0.7}" [style.backgroundImage]="'url('+ coverImage +')'" class="cover-img"></div> -->

      <uni-image
        [src]="competition?.image"
        [alt]="competition.title"
        [default]="defaultImage"
        auxClassList="cover-img">
      </uni-image>

      <h1 class="cover-bottom-header margin-0 absolute width-100 bottom-0" *ngIf="!isSmall">
        <div
          fxLayout="row"
          class="width-100 height-100 padding-x-5"
          fxLayoutAlign="space-between center">
          <p class="text sparro-white margin-0">
            {{ competition.tagline }}
          </p>

          <p class="flex-container margin-y-0 sparro-white" fxLayoutAlign="end center">
            <i class="icon-location-fill"></i>
            <span class="margin-0 location-text">
              <ng-container *ngIf="competition?.location?.name === 'Worldwide'; else location">
                {{ competition.location.name }}
              </ng-container>
              <ng-template #location>
                <span *ngIf="competition?.location?.city?.name"
                  >{{ competition.location.city.name }},&nbsp;</span
                >
                <span *ngIf="competition?.location?.country?.name">{{
                  competition.location.country.name
                }}</span>
              </ng-template>
            </span>
          </p>
        </div>
      </h1>
      <div
        class="relative sparro-bg-grey-100 width-100 padding-1 fx-none--n-sm"
        *ngIf="competition.announcements.length > 0">
        <p
          *ngFor="let announcement of competition.announcements"
          class="font-xs text-center sparro-grey-800"
          [innerHtml]="announcement.message | safeContent"></p>
      </div>

      <uni-share-button-group
        *ngIf="!isSmall"
        [item]="competition"
        [showFloatingShare]="isLarge"
        sourceCopy="competitions"
        [content]="sharedContent"
        [commentSectionTop]="container?.nativeElement.offsetTop"
        (comment)="goToComments($event)"
        source="competitions"
        [slug]="competition.slug"
        [user]="user">
      </uni-share-button-group>
    </header>

    <div
      *ngIf="competition?.announcements?.length > 0"
      class="width-100"
      fxLayout="column"
      fxLayoutGap="8px"
      class="bottom-margin">
      <p
        *ngFor="let announcement of competition.announcements"
        [innerHtml]="announcement.message | safeContent"
        class="font-xs text-center sparro-bg-white border-radius-2 sparro-grey-800 margin-y-0 announcement-container"></p>
    </div>
    <section
      fxLayout="column"
      fxLayoutAlign="center center"
      class="sparro-bg-white border-radius-3 padding-y-3"
      *ngIf="!isLarge">
      <h4 class="font-lg sparro-grey-900 font-bold margin-top-0 margin-bottom-4 fx-none--n-sm">
        {{ competition.title }}
      </h4>
      <h1 class="font-md font-regular sparro-grey-900 margin-top-0 margin-bottom-2 fx-none--n-sm">
        {{ competition.tagline }}
      </h1>

      <div class="margin-bottom-4 fx-none--n-sm fx-flex--gt-sm">
        <i class="icon-location-fill"></i>
        <span class="font-md margin-0 sparro-grey-900">
          <ng-container *ngIf="competition.location.name === 'Worldwide'; else locationTemplate">
            {{ competition.location.name }}
          </ng-container>
          <ng-template #locationTemplate>
            {{ competition.location.city ? competition.location.city?.name : '' }}
            {{ competition.location.city ? ',' : '' }} {{ competition.location?.country?.name }}
          </ng-template>
        </span>
      </div>

      <div
        fxLayout="row"
        class="margin-bottom-2"
        fxLayoutAlign="center"
        *ngIf="isRegistrationRound">
        <p
          class="font-sm-static sparro-grey-800 margin-0"
          *ngIf="competition.registration_deadline !== 'Closed'">
          <span class="font-sm-static font-bold sparro-grey-900">Register by:</span>
          {{ competition.registration_deadline.end_date | date }}
        </p>
      </div>
      <div fxLayout="row" class="margin-bottom-2" fxLayoutAlign="center" *ngIf="isSubmissionRound">
        <p
          class="font-sm-static sparro-grey-800 margin-0"
          *ngIf="competition.submission_deadline !== 'Closed'">
          <span class="font-sm-static font-bold sparro-grey-900">Submit by:</span>
          {{ competition.submission_deadline.end_date | date }}
        </p>
      </div>
      <div
        fxLayout="column"
        fxLayoutGap="8px"
        class="margin-bottom-6"
        fxLayoutAlign="center"
        *ngIf="isRegistrationRound && competition?.registration_deadline?.starting_category?.cost">
        <p class="font-sm-static sparro-grey-800 margin-0">
          <span class="font-bold sparro-grey-900">Registration starts:</span>
          {{ competition.registration_deadline.starting_category.cost }} USD
        </p>
        <span class="font-sm sparro-grey-900 text-center">
          Exclusive pass with
          <a
            href="https://uni.xyz/about/designers/membership"
            target="_blank"
            class="sparro-grey-900 font-bold"
            >UNI Membership</a
          >
        </span>
      </div>

      <div
        fxLayout="row"
        [ngClass]="{ 'margin-top-4': isMedium && !(isRegistrationRound || isSubmissionRound) }"
        fxLayoutAlign="center center"
        fxLayoutGap.gt-xs="24px"
        fxLayoutGap="10px">
        <uni-navigation-button
          *ngIf="isRegistrationRound"
          default="Register"
          button_class="primary"
          customClass="custom-button-sm"
          (click)="openDialog()">
        </uni-navigation-button>
        <uni-navigation-button
          *ngIf="isSubmissionRound"
          default="Submit entry"
          button_class="secondary"
          customClass="custom-button-sm"
          (click)="submitEntry()">
        </uni-navigation-button>
        <uni-navigation-button
          *ngIf="isVotingRound"
          default="Vote now"
          button_class="primary"
          customClass="custom-button-sm"
          (click)="goToEntries()">
        </uni-navigation-button>
        <uni-navigation-button
          *ngIf="isResultAnnounced"
          default="View result"
          button_class="primary"
          customClass="custom-button-sm"
          (click)="goToEntries()">
        </uni-navigation-button>
      </div>
    </section>

    <!-- <uni-tabs [isCompetitions]="true" [tabs]="tabs" [primary]="false" [chosen]="chosenTab" (tabSelected)="tabSelected($event)"></uni-tabs> -->

    <div fxLayout="row" class="relative margin-y-3" style="width: inherit" *ngIf="!isLarge">
      <section
        class="overflow-hidden"
        style="width: inherit"
        [ngStyle]="{ padding: showScroll ? '0 60px' : '0' }"
        #tabsContent>
        <div fxLayout="row" fxLayoutGap="16px" style="width: max-content" #chipSection>
          <ng-container *ngFor="let tab of tabs[0].brief">
            <ng-container *ngIf="tab.name == 'Jury' && tab?.count == 0; else defaultView">
              <a
                target="_blank"
                class="tab no-decor"
                fxLayout="row"
                fxLayoutAlign="center center"
                fxLayoutGap="8px"
                [href]="jurorPageUrl">
                <i [class]="tab.icon + ' font-md'"></i>
                <p class="margin-0">{{ tab.name }}</p>
              </a>
            </ng-container>
            <ng-template #defaultView>
              <a
                class="tab no-decor"
                [href]="tab.url"
                fxLayout="row"
                fxLayoutAlign="center center"
                fxLayoutGap="8px">
                <i [class]="tab.icon + ' font-md'"></i>
                <p class="margin-0">{{ tab.name }}</p>
              </a>
            </ng-template>
          </ng-container>
          <ng-container *ngFor="let tab of tabs[0].extras">
            <a
              class="tab no-decor"
              [href]="tab.url"
              fxLayout="row"
              fxLayoutAlign="center center"
              fxLayoutGap="8px">
              <i [class]="tab.icon + ' font-md'"></i>
              <p class="margin-0">{{ tab.name }}</p>
            </a>
          </ng-container>
        </div>
      </section>

      <div class="absolute cursor-pointer height-100 left-0" fxLayout="row" *ngIf="showScroll">
        <i
          class="icon-arrow-left sparro-bg-grey-100"
          style="font-size: 32px; line-height: 48px"
          (click)="scroll('left')"></i>
        <div
          class=""
          style="
            background: linear-gradient(to right, rgba(244, 244, 244, 1) 46%, rgba(0, 0, 0, 0) 80%);
            width: 32px;
          "></div>
      </div>
      <div class="absolute cursor-pointer height-100 right-0" fxLayout="row" *ngIf="showScroll">
        <div
          class=""
          style="
            background: linear-gradient(to left, rgba(244, 244, 244, 1) 46%, rgba(0, 0, 0, 0) 80%);
            width: 32px;
          "></div>
        <i
          class="icon-arrow-right sparro-bg-grey-100"
          style="font-size: 32px; line-height: 48px"
          (click)="scroll('right')"></i>
      </div>
    </div>

    <!-- Small and medium screen view -->
    <ng-container *ngIf="isSmall || isMedium">
      <section class="main-wrapper sparro-bg-white border-radius-3 padding-y-3 bottom-margin">
        <div class="main-md" #main>
          <div class="container-md">
            <router-outlet></router-outlet>
          </div>
        </div>

        <section class="mobile-main-footer">
          <div class="section-divider text-center">
            <i class="icon-3-horizontal-dots"></i>
          </div>

          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            class="reg-btn"
            fxLayoutGap.gt-xs="24px"
            fxLayoutGap="10px">
            <uni-navigation-button
              *ngIf="isRegistrationRound"
              default="Register"
              button_class="primary"
              customClass="custom-button-sm"
              (click)="openDialog()">
            </uni-navigation-button>
          </div>

          <ng-container *ngIf="isMedium || isSmall">
            <div
              fxLayout="row"
              class="share-footer-md width-100 padding-x-1"
              fxLayoutAlign="space-between center"
              fxLayoutGap="24px">
              <div fxLayout="column" fxLayoutAlign="center center">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="24px">
                  <uni-like-button
                    [item]="competition"
                    [source]="'competitions'"
                    [border]="true"
                    [showCount]="true">
                  </uni-like-button>

                  <div class="fx-flex align-items-center" fxLayoutGap="4px">
                    <i class="icon-comments"></i>
                    {{ competition.comments }}
                  </div>

                  <div class="competition-views">
                    {{ competition.views }} {{ competition.views > 1 ? 'views' : 'view' }}
                  </div>
                </div>
              </div>

              <div fxLayout="column" fxLayoutAlign="center center">
                <div fxLayout="row" class="share-menu-section" style="align-items: center">
                  <button mat-icon-button style="margin-left: 6px" (click)="openShareDialog()">
                    <uni-image
                      [src]="icons.share_fill"
                      alt="Share"
                      [default]="defaultImage"
                      [height]="24"
                      [width]="24"
                      classes="cursor-pointer">
                    </uni-image>
                  </button>
                  <button
                    mat-icon-button
                    style="margin-left: 6px"
                    (click)="toggleBookmark()"
                    matTooltipPosition="above"
                    matTooltip="{{
                      competition?.bookmark ? 'Remove from collection' : 'Add to collection'
                    }}">
                    <uni-image
                      [src]="competition?.bookmark ? icons.bookmark_fill_orange : icons.bookmark"
                      [default]="defaultImage"
                      alt="Bookmark"
                      classes="cursor-pointer"
                      [height]="24"
                      [width]="24">
                    </uni-image>
                  </button>

                  <!-- <button mat-icon-button [matMenuTriggerFor]="menu">
                      <mat-icon class="icon-3-vertical-dots-fill sparro-grey-800" style="vertical-align: text-bottom;"></mat-icon>
                    </button>
  
                    <mat-menu #menu="matMenu">
                      <ng-container>
                        <button mat-menu-item (click)="toggleFollow()">
                          <span>{{ competition.is_following ? 'Following' : 'Follow' }}</span>
                        </button>
                        <button mat-menu-item (click)="createReport()" *ngIf="!competition.report || competition.report?.status !== 'INITIATED'"
                          [disabled]="competition.report?.status === 'VERIFIED'">
                          <span>{{ competition.report?.status === 'VERIFIED' ? 'Reported' : 'Report' }}</span>
                        </button>
                        <button mat-menu-item *ngIf="competition.report?.status === 'INITIATED'" (click)="redactReport()">
                          <span>Redact</span>
                        </button>
                      </ng-container>
                    </mat-menu> -->
                </div>
              </div>
            </div>
          </ng-container>
        </section>
      </section>
      <div class="sparro-bg-white border-radius-3 padding-y-3 bottom-margin">
        <p class="font-sm sparro-grey-600 padding-x-3">Explore more under</p>

        <div class="margin-bottom-6 padding-x-3">
          <mat-chip-list class="discipline-section-sm">
            <mat-chip
              class="cursor-pointer"
              *ngFor="let discipline of disciplines"
              (click)="getDisciplineFilter(discipline)"
              [selectable]="true"
              [removable]="false">
              <ng-container *ngIf="discipline.icon">
                <uni-image
                  [src]="discipline.icon"
                  [default]="defaultImage"
                  [alt]="discipline.name"
                  [height]="30"
                  [width]="30"
                  auxClassList="mat-chip-image">
                </uni-image>
              </ng-container>
              <i class="icon-discipline" *ngIf="!discipline.icon"></i>
              <span>{{ discipline.name }}</span>
            </mat-chip>
          </mat-chip-list>
        </div>

        <mat-divider></mat-divider>

        <div
          class="margin-bottom-6 padding-x-3"
          *ngIf="competition.tags || competition.seo_keyword">
          <p class="font-sm sparro-grey-600 margin-bottom-6">Competition tags</p>

          <mat-chip-list class="tag-section-sm">
            <mat-chip
              class="cursor-pointer"
              *ngFor="let tag of competition.tags"
              [selectable]="false"
              [removable]="false">
              <ng-container *ngIf="tag.icon">
                <uni-image
                  [src]="tag.icon"
                  [default]="defaultImage"
                  [alt]="tag.name"
                  [height]="30"
                  [width]="30"
                  auxClassList="mat-chip-image">
                </uni-image>
              </ng-container>
              <i class="icon-tag" *ngIf="!tag.icon"></i>
              <span>{{ tag.name }}</span>
            </mat-chip>
            <mat-chip
              class="cursor-pointer"
              *ngFor="let keyword of competition.seo_keyword"
              [selectable]="false"
              [removable]="false">
              <i class="icon-tag"></i>
              <span>{{ keyword.name }}</span>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>

      <section class="bottomsheet-footer left-0" *ngIf="isSmall || isMedium">
        <div
          fxLayout="row"
          class="width-100 height-100"
          fxLayoutAlign="center center"
          fxLayoutGap="8px">
          <i
            [class]="
              (isBottomSheetOpen ? 'icon-arrow-down-fill' : 'icon-arrow-up-fill') +
              ' cursor-pointer'
            "
            (click)="isBottomSheetOpen ? closeBottomSheet() : openBottomSheet()"></i>

          <uni-navigation-button
            *ngIf="isRegistrationRound"
            default="Register"
            button_class="primary"
            [customClass]="'bottomsheet-button'"
            (click)="openDialog()">
          </uni-navigation-button>
          <uni-navigation-button
            *ngIf="isSubmissionRound && !isRegistrationRound"
            default="Submit entry"
            button_class="secondary"
            [customClass]="'bottomsheet-button'"
            (click)="submitEntry()">
          </uni-navigation-button>
          <uni-navigation-button
            *ngIf="isVotingRound"
            default="Vote now"
            button_class="primary"
            [customClass]="'bottomsheet-button'"
            (click)="goToEntries()">
          </uni-navigation-button>
          <uni-navigation-button
            *ngIf="isResultAnnounced"
            default="View result"
            button_class="primary"
            [customClass]="'bottomsheet-button'"
            (click)="goToEntries()">
          </uni-navigation-button>
        </div>
      </section>
    </ng-container>

    <!-- Large screen view -->
    <div *ngIf="isLarge" #desktopViewContainer>
      <div class="main-gt-md border-radius-3 bottom-margin">
        <div
          class="container-gt-md padding-y-3"
          [ngClass]="{
            'custom-container-gt-md':
              router.url.includes('entries') || router.url.includes('leaderboard')
          }">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
    <div
      *ngIf="!isRegistrationRound && similarCompetitions?.length > 0"
      class="sparro-bg-white border-radius-3 bottom-margin padding-y-3">
      <ng-container *ngTemplateOutlet="similarSection"> </ng-container>
    </div>
  </ng-template>
  <footer>
    <uni-public-footer></uni-public-footer>
  </footer>

  <ng-template #similarSection>
    <div class="explore-more-section">
      <p class="font-md font-bold margin-bottom-2 sparro-grey-900">
        Competitions similar to {{ competition.title }}
      </p>
      <p class="margin-0 font-xxs sparro-grey-700">
        Explore more competitions under
        <ng-container *ngIf="competition.disciplines?.length > 0">
          <ng-container *ngFor="let item of competition.disciplines; let last = last">
            {{ item.name }}<span *ngIf="!last">, </span>
          </ng-container>
        </ng-container>
      </p>

      <div class="width-100 margin-auto margin-top-8" [ngClass.gt-sm]="{ 'padding-x-2': true }">
        <uni-competition-cards-group
          [competitions]="similarCompetitions"
          [display]="'breakpoint'"
          align="center">
        </uni-competition-cards-group>
      </div>

      <div fxLayout="row" fxLayoutAlign="center center" class="margin-4">
        <a [href]="exploreMore()" class="no-decor">
          <uni-navigation-button
            default="Explore more"
            button_class="secondary"
            icon_class="icon-open-in-new-tab">
          </uni-navigation-button>
        </a>
      </div>
    </div>
  </ng-template>
</main>

<ng-template #sidenavContent>
  <div class="sparro-bg-white" style="width: 296px" *ngIf="competition">
    <app-comp-detail-sidenav
      [competition]="competition"
      [modules]="tabs"
      [selected]="chosenTab"
      [coverScrolled]="coverScrolled"
      [isRegistrationRound]="isRegistrationRound"
      [isSubmissionRound]="isSubmissionRound"
      [isVotingRound]="isVotingRound"
      [isResultAnnounced]="isResultAnnounced"
      (register)="openDialog($event)"
      (navLink)="tabSelected($event)"
      (discipline)="getDisciplineFilter($event)">
    </app-comp-detail-sidenav>
  </div>
</ng-template>
